export default __webpack_public_path__ + "static/media/sel_exercises.60d4dc9a.svg";